import React, { useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Input } from 'antd'
import {
  createUrl,
  getQueryParams,
} from '../../../../core/utils/services/queryParams'

const MenuUrlFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()
  const { menuUrl } = getQueryParams(search)
  const [url, setUrl] = useState(menuUrl)

  const onSearch = useCallback(
    menuUrl => {
      history.push(
        createUrl(pathname, search, {
          menuUrl,
        }),
      )
    },
    [history, pathname, search],
  )

  return (
    <Form.Item
      label="Menu URL"
      colon={false}
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
    >
      <Input.Search
        value={url}
        onChange={({ target: { value } }) => setUrl(value)}
        onSearch={onSearch}
        allowClear
      />
    </Form.Item>
  )
}

export default MenuUrlFilter
